import React, { useState } from "react";
import { Popover } from "antd";
import { Link } from "react-router-dom";
import TopbarUserWrapper from "./TopbarUser.style";
import { withTheme } from "styled-components";
import { LogoutOutlined, RightOutlined, UserOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

const TenantsTopBarUser = (props) => {
  const { theme, direction } = props;
  const [visible, setVisible] = useState(false);
  const user_name = useSelector((state) => state.user.profile.name);

  const handleVisibleChange = () => {
    setVisible(!visible);
  };
  const content = (
    <TopbarUserWrapper data-rtl={direction}>
      <div>
        <Link
          to={{
            pathname: `/settings`,
            category: "profile",
          }}
        >
          <div className="itemContainer">
            <div className="itemLeft">
              <UserOutlined />
            </div>

            <div className="itemMiddle">
              <p className="primaryText">{user_name}</p>
            </div>
          </div>
        </Link>
        <div className="devider" />

        <Link to={`/logout`}>
          <div className="itemContainer">
            <div className="itemLeft">
              <div className="iconContainer">
                <LogoutOutlined />
              </div>
            </div>
            <div className="itemMiddle">
              <p className="primaryText">
                {<FormattedMessage id="app.topbar.logout" />}
              </p>
            </div>

            <div className="itemRight">
              <RightOutlined />
            </div>
          </div>
        </Link>
      </div>
    </TopbarUserWrapper>
  );

  return (
    <TopbarUserWrapper>
      <Popover
        content={content}
        placement={"bottom"}
        trigger="click"
        open={visible}
        onOpenChange={handleVisibleChange}
        arrow={{ pointAtCenter: true }}
      >
        <div className="topbarUserContainer">
          <UserOutlined
            style={{
              padding: "5px",
              background: theme.palette["surfaceColor"][0],
              borderRadius: "20px",
              fontSize: "16px",
            }}
          />
          <p className="topbarUserName">{user_name}</p>
          <span className="userActivity online" />
        </div>
      </Popover>
    </TopbarUserWrapper>
  );
};

export default withTheme(TenantsTopBarUser);
